import TreeViewNavbar from "../../components/Tree/TreeViewNavbar";
import SponserTreeContent from "../../components/Tree/sponser-tree/SponserTreeContent";
import { useState } from "react";
import { ApiHook } from "../../hooks/apiHook";

const SponserTree = () => {
  const [selectedUserId, setSelectedUserId] = useState("");
  const [searchUsername, setSearchUsername] = useState("");
  const [searchUserId, setSearchUserId] = useState("");

  const [doubleClickedUser, setDoubleClickedUser] = useState("");
  // api
  const sponserTree = ApiHook.CallSponsorTreeList("", "", searchUsername, searchUserId);
  return (
    <>
      <TreeViewNavbar
        menu={"sponsorTree"}
        searchUsername={searchUsername}
        setSearchUsername={setSearchUsername}
        setSelectedUserId={setSelectedUserId}
        setSearchUserId={setSearchUserId}

      />
      <SponserTreeContent
        selectedUserId={selectedUserId}
        setSelectedUserId={setSelectedUserId}
        doubleClickedUser={doubleClickedUser}
        setDoubleClickedUser={setDoubleClickedUser}
        searchUsername={searchUsername}
        setSearchUsername={setSearchUsername}
        isLoading={sponserTree.status === "loading" || sponserTree.fetchStatus === "fetching"}
      />
    </>
  );
};

export default SponserTree;